import React from "react";
import { LucideIcon } from "lucide-react";

interface DonationHeaderProps {
  icon: LucideIcon;
  title: string;
}

export function DonationHeader({ icon: IconComponent, title }: DonationHeaderProps) {
  return (
    <div className="flex items-center gap-3 mb-6">
      <IconComponent className="w-8 h-8 text-purple-600" />
      <h1 className="text-2xl font-bold">{title}</h1>
    </div>
  );
}